import React from 'react';
import Box from '@mui/material/Box';
import { Fade } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { makeStyles } from 'tss-react/mui';
import TitleBar from '../components/nav/title-bar';
import { DEFAULT_FADE_ANIMATION } from '../constants';
import { useSettings } from '../context-providers/settings-provider';
import ImageUploader from '../components/input/image-uploader';

const useStyles = makeStyles()(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    userImg: {
        margin: '10px',
        width: '80px',
        height: '80px',
    },
    photoButton: {
        position: 'relative',
        display: 'inline-block',
    },
}));

export default function Settings() {
    const { publicSettings, updateSettings: updatePublicSettings } = useSettings();
    const { classes } = useStyles();

    function onPropChange(propName: any, value: any) {
        updatePublicSettings({
            ...publicSettings,
            [propName]: value,
        });
    }

    return (
        <Box>
            <TitleBar title={publicSettings.username} />
            <Fade in timeout={DEFAULT_FADE_ANIMATION}>
                <Box className={classes.root}>
                    <Avatar alt={publicSettings.username.toLocaleUpperCase()} src={publicSettings.img || '#'} className={classes.userImg} />
                    <ImageUploader
                        className={classes.photoButton}
                        buttonText={`${publicSettings.img ? 'Edit' : 'Add'} photo`}
                        onChange={(img) => onPropChange('img', img)}
                    />
                </Box>
            </Fade>
        </Box>
    );
}
